import Vue from 'vue'
import Router from 'vue-router'
import multiguard from 'vue-router-multiguard'
import {
  disableErrorRouteManualNavigation,
  setPageTitleFromRoute,
  trackPage,
  walletRouterGuard
} from './middleware'
import { routes } from './routes'
import ServiceRegistry from '@/service/registry/ServiceRegistry'
import { NotificationService } from '@/service/notification/NotificationService'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior () {
    // scroll to the top of the page on each route change
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  ServiceRegistry.inject(NotificationService).clear()
  return multiguard([
    disableErrorRouteManualNavigation,
    setPageTitleFromRoute,
    walletRouterGuard
  ])(to, from, next)
})

router.afterEach(trackPage)

export default router
